import React from "react";
import { Row } from "common/components";
import StepActionsButton from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
function RowActions({ step, eventId }) {
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "auto" }, /* @__PURE__ */ React.createElement(StepActionsButton, { step, eventId }));
}
export default RowActions;
